module.exports = __webpack_public_path__ + "static/media/icon-logout.8d9972b8.svg";